const state = {
  loading: false
}

const getters = {
  loading: (state) => {
    return state.loading
  }
}

const actions = {
  loader ({ commit }, status) {
    if (status === 'close') {
      commit('hideLoader')
    } else {
      commit('showLoader')
    }
  }
}

const mutations = {
  showLoader (state) {
    state.loading = true
  },
  hideLoader (state) {
    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
